<template>
  <div class="productOptions__comingSoonWrapper">
    <div class="productOptions__comingSoonTitleWrapper">
      <img
        src="
        https://res.cloudinary.com/legrandav/image/upload/v1710190394/calendar.svg
        "
      />
      <h3 class="productOptions__comingSoonTitle">
        This item is coming soon
      </h3>
    </div>
    <h4 class="productOptions__comingSoonDescription">
      We are giving a preview of this item before its release. Item and product
      details are subject to change.
    </h4>
  </div>
</template>

<script>
export default {
  components: {}
};
</script>

<style lang="scss" scoped>
.productOptions {
  &__comingSoonWrapper {
    margin-top: 0;
    padding: 16px;
    background-color: #d7efeb;
    border: 1px solid $gray;

    @include media-breakpoint-up(sm) {
      margin-top: -25px;
    }
  }
  &__comingSoonTitleWrapper {
    display: flex;
    align-items: center;
  }
  &__comingSoonTitle {
    font-family: $heading;
    font-weight: bold;
    color: $black85;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.2px;
    margin: 0 0 0 12px;

    @include media-breakpoint-up(md) {
      font-size: 20px;
      line-height: 30px;
      letter-spacing: 0;
    }
  }
  &__comingSoonDescription {
    font-family: $body;
    font-weight: 500;
    color: $black85;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0.4px;
    margin-bottom: 0;

    @include media-breakpoint-up(md) {
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0.2px;
    }
  }
}
</style>
